import { RouterProvider } from 'react-router-dom';
import { router } from './router.tsx';
import ToastProvider from '@/components/ToastProvider.tsx';

function App() {
  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  );
}

export default App;
